<template>
    <span v-if="noticeItem.actions.supplier.proposal.create || noticeItem.actions.supplier.proposal.edit" class="ml-2">
        <template v-if="$store.state.organization.available_fl44_proposal_submission_status.id === 'blocked'">
            <b-button v-if="noticeItem.actions.supplier.proposal.create" :id="'popover-fl44-' + noticeItem.id" class="fs-14 mt-2" target="_blank" variant="custom-green"> Подать предложение </b-button>
            <b-button v-if="noticeItem.actions.supplier.proposal.edit" :to="{ name: 'Fl44UnknownVolumePurchaseNewProposal', params: { id: noticeItem.id } }" class="fs-14 mt-2" target="_blank" variant="custom-golden"> Изменить предложение</b-button>
            <b-popover :target="'popover-fl44-' + noticeItem.id" triggers="hover">
                <p class="fs-12 my-1 py-1">{{ $store.state.organization.available_fl44_proposal_submission_status.title }} до {{ $store.state.organization.expiration_datetime_blocking_fl44_proposal_submission }}</p>
            </b-popover>
        </template>
        <template v-else-if="hasRestrictions">
            <b-button v-if="noticeItem.actions.supplier.proposal.create" :id="'popover-fl44-' + noticeItem.id" class="fs-14 mt-2" target="_blank" variant="custom-green"> Подать предложение </b-button>
            <b-button v-if="noticeItem.actions.supplier.proposal.edit" :id="'popover-fl44-' + noticeItem.id" class="fs-14 mt-2" target="_blank" variant="custom-golden"> Изменить предложение </b-button>
            <b-popover :target="'popover-fl44-' + noticeItem.id" triggers="hover">
                <p v-if="noticeItem.restrictions.money.status" class="fs-12 my-1 py-1">
                    Необходимо для блокировки <span class="fw-600 text-nowrap">{{ $formatPrice(noticeItem.fee_amount) }}</span> руб. <br />Для подачи предложения не хватает
                    <span class="text-danger fw-600 text-nowrap">{{ $formatPrice(noticeItem.restrictions.money.not_enough) }}</span> руб.<br />
                    <router-link :to="{ name: 'CabinetAccounting' }" class="system_link-style">Пополнить лицевой счет</router-link>
                    .
                </p>
                <p v-if="noticeItem.restrictions.smp.status" class="fs-12 my-1 py-1">Подача предложения невозможна, так как Ваша организация не является СМП.</p>
            </b-popover>
        </template>
        <template v-else>
            <b-button v-if="noticeItem.actions.supplier.proposal.create" :to="{ name: 'Fl44UnknownVolumePurchaseNewProposal', params: { id: noticeItem.id } }" class="fs-14 mt-2" target="_blank" variant="custom-green"> Подать предложение</b-button>
            <b-button v-if="noticeItem.actions.supplier.proposal.edit" :to="{ name: 'Fl44UnknownVolumePurchaseNewProposal', params: { id: noticeItem.id } }" class="fs-14 mt-2" target="_blank" variant="custom-golden"> Изменить предложение</b-button>
        </template>
    </span>
</template>

<script>
export default {
    name: 'fl44-unknown-volume-new-proposal-button',
    props: {
        noticeItem: {
            type: Object,
            required: true
        }
    },
    computed: {
        hasRestrictions() {
            return this.noticeItem.restrictions.money.status || this.noticeItem.restrictions.smp.status;
        }
    }
};
</script>
